import { List, Text } from '@/ui'

export const AlternativeItem = ({
  title,
  price,
  cadence,
}: {
  title: string
  price: string
  cadence?: string
}) => {
  return (
    <List.Item className="mt-1 mb-6 flex-1 flex">
      <div className="flex items-center justify-between">
        <div className="flex-grow">
          <Text className="text-sm">{title}</Text>
        </div>

        <div className="flex items-baseline justify-end">
          <Text className="text-[22px] font-semibold">{price}</Text>
          {cadence && <Text className="text-base mb-0.5">/{cadence}</Text>}
        </div>
      </div>
    </List.Item>
  )
}
